import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import Intro from "./Intro";
import Background from "./Background";
import Loader from "../../components/loader";
import useGetAdminConfigs from "../../hooks/useGetAdminConfigs";
import useGetSiteImages from "../../hooks/useGetSiteImages";
import { setHomePageVisited } from "../../features/appSlice";

const Home = () => {
  const introRef = useRef(null);
  const dispatch = useDispatch();
  const isHomePageVisited = useSelector((state) => state.app.isHomePageVisited);

  const handleHomePageVisited = () => {
    dispatch(setHomePageVisited());
  };

  const {
    configs: { descriptionBody, descriptionTitle },
    isLoadingConfigs,
  } = useGetAdminConfigs();
  const { isLoadingSiteImages } = useGetSiteImages();

  const startHandler = () => {
    document.body.style.overflow = "auto";

    introRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });

    setTimeout(() => {
      handleHomePageVisited();
    }, 2000);
  };

  useEffect(() => {
    if (!isHomePageVisited) {
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isHomePageVisited]);

  if (isLoadingConfigs || isLoadingSiteImages) {
    return <Loader />;
  }

  return (
    <div className={`overflow-y-hidden scroll-smooth`}>
      {!isHomePageVisited && (
        <div className="h-dvh">
          <Background onStartNowClick={startHandler} />
        </div>
      )}
      <Intro
        title={descriptionTitle}
        body={descriptionBody}
        innerRef={introRef}
      />
    </div>
  );
};

export default Home;
